import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import Dashboard from "../pages/adminpanel/sidebar";
import Home from "../pages/home";
import ProductPage from "../pages/productdetail";
import Shop from "../pages/shop";
import About from "../pages/About";
import PrivacyPolicy from "../comopnents/PrivacyPolicy";
import TermsConditions from "../comopnents/Termsconditions";
import RefundPolicy from "../comopnents/RefundPolicy";
import CancellationPolicy from "../comopnents/cancel";
import Cart from "../pages/Cart";
import ContactUs from "../pages/ContactUs";
import ProfilePage from "../pages/profile";
import SearchResults from "../pages/SearchResults";
import ShopbySpares from "../pages/shopbyspares";
import AdminPanel from "../pages/adminpanel/sidebar";
import Checkout from "../pages/Checkout";
import Wishlist from "../comopnents/Wishlist";
import Orders from "../comopnents/orders";
import Address from "../comopnents/address";
// import Login from "../comopnents/Login";
// import SignUp from "../comopnents/signup";
import Header from "../comopnents/Header";
import BrandProducts from "../pages/BrandProducts";
import PurchaseResult from "../pages/PurchaseResult";
import OrderDetails from "../pages/OrderDetails";
import Invoice from "../pages/Invoice";
import ShopByCategory from "../pages/shopbycategory";
import Coupons from "../comopnents/Coupons";
import ServiceHistory from "../pages/ServiceHistory";
import EditStatus from "../pages/EditStatus";
import CategoriesPage from "../pages/CategoriesPage";
import Blogs from "../pages/blogs";
import BlogDetails from "../pages/BlogDetails";
import Dealer from "../pages/Dealer";
import Warranty from "../pages/warranty";
import VerificationList from "../pages/VerificationList";
import WarrantySuccess from "../comopnents/warrantysuccess";
import SocialMedia from "../comopnents/socialmedia";
import AlreadyVerified from "../comopnents/alreadyverified";
import InvalidProduct from "../comopnents/ivalidproductcode";
import VerificationSuccess from "../comopnents/verificationsuccess";
import RegisterWarrenty from "../comopnents/RegisterWarrenty";
import WarrantyList from "../pages/warrantyList";
import WarrantyClaim from "../pages/warrantyClaim";
import LuckyDraw from "../comopnents/luckydraw";
import WinnerReveal from "../comopnents/winnerreveal";
import WinnerList from "../comopnents/winnerslist";


const AppRoutes = () => {
  const location = useLocation();
  const isSuperAdmin = localStorage.getItem("userType") === "SuperAdmin";
  const isWarehouse = localStorage.getItem("userType") === "Warehouse";
  const isManager = localStorage.getItem("userType") === "Digital Manager";
  const isSales = localStorage.getItem("userType") === "Sales";
  const isMarketingManager = localStorage.getItem("userType") === "Marketing Manager";
  const isAccounts = localStorage.getItem("userType") === "Accounts";
  const isTelemarketer = localStorage.getItem("userType") === "telecalling";
  const issales = localStorage.getItem("userType") === "sales";
  const Accounts = localStorage.getItem("userType") === "Accounts";

  return (
    <Routes>
      {(isSuperAdmin ||
        isWarehouse ||
        isSales ||
        isMarketingManager ||
        isAccounts ||
        isManager ||
        isTelemarketer) && (
          <Route path="/adminsidebar" element={<AdminPanel />} />
        )}
      <Route path="/" element={<Home />} />
      {/* <Route path="/login" element={<Login />} /> */}
      <Route path="/productdetail" element={<ProductPage />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/About" element={<About />} />
      <Route path="/search" element={<SearchResults />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="*" element={<Navigate to="/" />} />
      <Route path="/privacypolicy" element={<PrivacyPolicy />} />
      <Route path="/T&C" element={<TermsConditions />} />
      <Route path="/refundpolicy" element={<RefundPolicy />} />
      <Route path="/cancelltionpolicy" element={<CancellationPolicy />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/PurchaseResult" element={<PurchaseResult />} />
      <Route path="/ContactUs" element={<ContactUs />} />
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/Invoice/:orderid" element={<Invoice />} />
      <Route path="/shopbyspares" element={<ShopbySpares />} />
      <Route path="/shopbycategory" element={<ShopByCategory />} />
      <Route path="/brandproducts" element={<BrandProducts />} />
      <Route path="/categories" element={<CategoriesPage />} />
      <Route path="/ServiceHistory" element={<ServiceHistory />} />
      <Route path="/EditStatus" element={<EditStatus />} />
      {/* <Route path="/adminsidebar" element={<AdminPanel />} /> */}
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/wishlist" element={<Wishlist />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/address" element={<Address />} />
      {/* <Route path="/signup" element={<SignUp />} /> */}
      <Route path="/coupons" element={<Coupons />} />
      <Route path="/Blogs" element={<Blogs />} />
      <Route path="/blogs/:slug" element={<BlogDetails />} />
      <Route path="/order-details/:orderid" element={<OrderDetails />} />
      <Route path="/Dealer" element={<Dealer />} />
      <Route path="/alreadyVerified" element={<AlreadyVerified />} />
      <Route path="/verificationSuccess" element={<VerificationSuccess />} />
      <Route path="/register-warranty" element={<RegisterWarrenty />} />
      {/* <Route path="/warranty" element={<Warranty key={location.state?._w || location.key} />} /> */}
      <Route path="/warranty" element={<Warranty />} />
      <Route path="/VerificationList" element={<VerificationList />} />
      <Route path="/warrantysucess" element={<WarrantySuccess />} />
      <Route path="/socialmedia" element={<SocialMedia />} />
      <Route path="/invalidproduct" element={<InvalidProduct />} />
      <Route path="/warrantyList" element={<WarrantyList />} />
      <Route path="/warrantyClaim" element={<WarrantyClaim />} />
      <Route path="/luckydraw" element={<LuckyDraw/>} />
      <Route path="/winner-reveal" element={<WinnerReveal/>} />
      <Route path="/winner-list" element={<WinnerList/>} />






    </Routes>

  );
};

export default AppRoutes;
